module.exports = __webpack_public_path__ + "static/img/dgnt-img2.d6f3bc34.jpeg";